import { ISubscriptionPlan } from '../interface/ISubscriptionPlan'

const essentialPack: ISubscriptionPlan = {
  title: 'Essential',
  moduleId: 15,
  price: {
    nl: 29,
    be: 59,
  },
  isBestPick: false,
  features: [
    'Calendar',
    'Online booking',
    'Customer management',
    '2 Users',
    'Chat support',
  ],
}

const basicPack: ISubscriptionPlan = {
  title: 'Basic',
  moduleId: 18,
  price: {
    nl: 39,
    be: 79,
  },
  isBestPick: false,
  features: [
    'Everything from essential',
    'Register',
    'Reports',
    'Marketing',
    'No show emails',
    '4 Users',
  ],
}

const basicPlusPack: ISubscriptionPlan = {
  title: 'Basic plus',
  moduleId: 17,
  price: {
    nl: 49,
    be: 89,
  },
  isBestPick: true,
  features: [
    'Everything from basic',
    'Stock management',
    'Statistics',
    'Unlimited # of users',
  ],
}

const proPack: ISubscriptionPlan = {
  title: 'Pro',
  moduleId: 20,
  price: {
    nl: 79,
    be: 109,
  },
  isBestPick: false,
  features: [
    'Everything from basic plus',
    'Online giftcards',
    'Loyalty cards',
    'Subscriptions',
    'HR Module',
    'Workshops',
  ],
}

export const planArray = [essentialPack, basicPack, basicPlusPack, proPack]
